const charTable = {
    Ä: 'Ae',
    ä: 'ae',
    Ö: 'Oe',
    ö: 'oe',
    Ü: 'Ue',
    ü: 'ue',
    ß: 'ss',
    ' ': '-',
    '–': '-',
    ',': '',
    ';': '',
    '/': '_',
    '„': '',
    '“': '',
};
const cleanChars = (c) => {
    const replacement = charTable[c];
    if (replacement || replacement === '') {
        return replacement;
    }
    return c;
};
export const cleanUrlPathPart = (text) => {
    if (!text) {
        return '';
    }
    return text
        .replace(/[^A-Za-z0-9,;]/g, cleanChars)
        .replace(/(-)+/g, '-')
        .toLowerCase();
};
//# sourceMappingURL=urlUtils.js.map